import React from "react";

import { useControls } from "../utils";
import { CloseLast } from "./closeLast";
import { OpenLast } from "./openLast";
import { CloseAll } from "./closeAll";
import { OpenAll } from "./openAll";
import { Props } from "./types";
import styles from "./styles.scss";

function Controls(props: Props) {
  const controls = useControls();

  return (
    <div className={styles.controls}>
      <CloseLast
        isDisabled={!controls.canCollapse}
        toggle={controls.collapseLast}
      />
      <OpenLast isDisabled={!controls.canOpen} toggle={controls.extendLast} />
      <CloseAll
        isDisabled={!controls.canCollapse}
        toggle={controls.collapseAll}
      />
      <OpenAll isDisabled={!controls.canOpen} toggle={controls.extendAll} />
    </div>
  );
}

export { Controls };
